import { render, staticRenderFns } from "./CatalogoReferenciasObras.vue?vue&type=template&id=35372fb8"
import script from "./CatalogoReferenciasObras.vue?vue&type=script&lang=js"
export * from "./CatalogoReferenciasObras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports